module.exports = __webpack_public_path__ + "static/media/referral-Light.80e69f65.svg";